namespace TabAurous.Administration {
    export interface PushNotifyConfigRow {
        Id?: number;
        AppId?: string;
        ApiKey?: string;
    }

    export namespace PushNotifyConfigRow {
        export const idProperty = 'Id';
        export const nameProperty = 'AppId';
        export const localTextPrefix = 'Administration.PushNotifyConfig';
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            Id = "Id",
            AppId = "AppId",
            ApiKey = "ApiKey"
        }
    }
}
